import { Component } from "vue-property-decorator"

import FloatingActionButtonBase from "./floatingActionButton.client.base"

@Component
export default class FloatingActionButton extends FloatingActionButtonBase {}
